import React from "react";
import { motion } from "framer-motion";
import { Inline } from "./Inline";

export function DataTable({ head, rows }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="my-8 overflow-x-auto border border-[var(--border-heavy)]"
      data-testid="data-table"
    >
      <table className="w-full border-collapse text-[13.5px]">
        <thead>
          <tr className="bg-[#1C2430] text-[#FBFBF9]">
            {head.map((h, i) => (
              <th
                key={i}
                className="text-left font-mono-ui text-[10px] uppercase tracking-[0.14em] font-semibold px-4 py-3 border-r border-white/10 last:border-r-0"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, ri) => (
            <tr key={ri} className="border-t border-[var(--border-light)] odd:bg-black/[0.015] align-top">
              {r.map((cell, ci) => (
                <td key={ci} className="px-4 py-3 border-r border-[var(--border-light)] last:border-r-0 leading-relaxed text-[#1C2430]/85">
                  <Inline text={cell} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </motion.div>
  );
}
